<template>
  <div class="row h-100 authorizationManagement">
    <div class="col-xl-11" :class="btnRoleListCollapse ? 'ml-5' : null">
      <div class="row">
        <div class="col-md-5 col-lg-3">
          <div v-if="btnRoleListCollapse">
            <button type="button" class="btn iconArrowToggleLeft" @click="btnRoleListCollapse = !btnRoleListCollapse" />
          </div>
          <div v-else-if="!btnRoleListCollapse" class="userSaleInfos bgDarkBlueGrey">
            <button type="button" class="btn iconArrowToggleRight" @click="btnRoleListCollapse = !btnRoleListCollapse" />
          </div>
          <section v-if="!btnRoleListCollapse" class="treeViewSidebar">
            <!-- tab menu -->
            <div class="row">
              <section class="col-12 mainTabMenu">
                <b-tabs
                  :id="'AuthorizationManagementTab'"
                  v-model="selectedTabIndex"
                  pills
                  fill
                  justified
                  :nav-class="'scrollbar tabChange d-none'"
                  :active-nav-item-class="'bg-primary'"
                >
                  <b-tab :title-link-class="'btn-lg'" active>
                    <!-- tab area  -->
                    <!-- role head -->
                    <section class="row">
                      <div class="col-12">
                        <h6 class="head">{{ headerText }}</h6>
                      </div>
                    </section>
                    <!-- search -->
                    <section class="row searchRow p-0 align-items-center">
                      <div class="col">
                        <div class="form-group">
                          <input
                            v-model="filterSearchInput"
                            aria-label="searchRoleInput"
                            class="form-control searchInput"
                            type="text"
                            placeholder="Rol arayınız"
                            @input="filterSearchRoles"
                          />
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="form-group">
                          <button type="button" class="btn btnAdd" @click="$emit('emitAddNewRole')" />
                        </div>
                      </div>
                    </section>

                    <!-- role radio button -->
                    <!-- bu lsitede rollerden herhangi biri seçilince (click olunca) diğer roller yok oluyor (v-show) -->
                    <div class="row roleRadioBtnArea">
                      <!--text-->
                      <div class="col-12">
                        <p class="textRoleSearch">{{ textRoleSearch }}</p>
                      </div>
                      <!--<template v-for="roleWithSubModel in rolesWithSubModels">-->
                      <template v-for="(roleWithSubModel, roleWithSubModelIndex) in filteredRolesWithSubModels">
                        <div
                          :id="'scrollRoleWithSubModel' + roleWithSubModel.id + roleWithSubModelIndex"
                          :key="'scrollRoleWithSubModel' + roleWithSubModel.id + roleWithSubModelIndex"
                          class="col-12"
                        >
                          <button
                            v-b-tooltip="{
                              customClass: 'tooltipUser',
                              trigger: 'hover',
                              html: true,
                            }"
                            type="button"
                            class="btn tooltipType btnRole w-100 text-left"
                            :class="{ active: selectedTempId === roleWithSubModel.tempId }"
                            :title="roleWithSubModel.name"
                            @click="$emit('emitSelectRoleWithSubModel', roleWithSubModel)"
                          >
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="text-truncate">
                                {{ roleWithSubModel.name }}
                              </span>

                              <div class="d-flex flex-column align-items-end">
                                <span class="text textEdit mb-1" @click="$emit('emitEntityNameFromEdit', roleWithSubModel)">Düzenle</span>
                                <span v-if="roleWithSubModel.id > 0" class="stationTable">
                                  <entity-status :page-name="enumHelper['ROLE']" :get-entity-status-props="getEntityStatus(roleWithSubModel)" />
                                </span>
                              </div>
                            </div>
                          </button>
                        </div>
                      </template>
                    </div>
                  </b-tab>
                </b-tabs>
              </section>
            </div>
            <div class="kilometricBasedPricing">
              <div class="card statusArea">
                <div class="card-body">
                  <work-flow-control-box
                    :publish-permission="publishPermission"
                    :update-permission="updatePermission"
                    :reject-permission="rejectPermission"
                    :recall-permission="recallPermission"
                    :cancel-permission="cancelPermission"
                    :submit-for-approval-permission="submitForApprovalPermission"
                    :delete-permission="deletePermission"
                    :loading-btn-state="loadingBtnState"
                    :pricing-page="true"
                    :save-enabled="!rejectPermission && !recallPermission && !submitForApprovalPermission"
                    :custom-class="'kilometricBasedPricingWorkFlowControlBox'"
                    :make-update-visible="false"
                    @publish="
                      $emit('emitPublish');
                      filterSearchInput = '';
                    "
                    @reject="
                      $emit('emitReject');
                      filterSearchInput = '';
                    "
                    @recall="
                      $emit('emitRecall');
                      filterSearchInput = '';
                    "
                    @cancel="
                      $emit('emitCancel');
                      filterSearchInput = '';
                    "
                    @submitForApproval="
                      $emit('emitSubmitForApproval');
                      filterSearchInput = '';
                    "
                    @updateSelectedEntity="
                      $emit('emitUpdateSelectedEntity');
                      filterSearchInput = '';
                    "
                    @saveChanges="
                      $emit('emitSaveChanges');
                      filterSearchInput = '';
                    "
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
        <div :class="btnRoleListCollapse ? 'col-md-11 col-lg-11' : 'col-md-7 col-lg-9'">
          <b-overlay
            :show="isNotSelectedRole || isSelectedRoleStatusWaitingApproval"
            :opacity="'1'"
            :blur="'0'"
            :bg-color="'rgba(0, 0, 0, 0.45)'"
            :z-index="'1'"
            rounded="sm"
          >
            <template #overlay>
              <div class="counterSeatSelection">
                <div class="trainSeatMapArea">
                  <div class="seatMapUserArea bg-transparent">
                    <div class="row overlayArea">
                      <div class="col-12">
                        <div class="text-center">
                          <img src="../../public/src/images/icon-warning-circle-white.svg" alt="icon-warning-circle-white" />
                          <p>{{ overlayWarningMessage }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="row">
              <!--add remove button-->
              <div class="col-12 position-relative">
                <div class="btnTreeViewArea">
                  <button type="button" class="btn btnAdd" :disabled="selectedRolesToBeAdded.length === 0" @click="addChosenRole()">Ekle</button>
                  <button type="button" class="btn btnRemove" :disabled="selectedRolesToBeRemoved.length === 0" @click="removeChosenRole()">Çıkar</button>
                </div>
              </div>
              <div class="col-md-6">
                <section class="unitTree">
                  <!-- selected items -->
                  <div class="selectedTreeView">
                    <div class="row no-gutters h-100">
                      <div class="col-12 customHeight">
                        <div class="row no-gutters">
                          <!-- head -->
                          <section class="col-12">
                            <h1 class="head">{{ leftListHeadText }}</h1>
                          </section>
                          <!-- custom hr -->
                          <section class="col-12">
                            <hr class="customHr" />
                          </section>
                          <section class="col-12 mainTabMenu">
                            <b-tabs
                              :id="'AuthorizationManagementTreeViewTab'"
                              v-model="selectedTreeViewTabIndex"
                              pills
                              fill
                              justified
                              :nav-class="'scrollbar tabChange'"
                              :active-nav-item-class="'bg-primary'"
                            >
                              <b-tab title="Yetki Listesinden Seç" active>
                                <!-- tab area  -->

                                <!--search-->
                                <input
                                  v-model="searchTextArrangedCategories"
                                  aria-label="pickAuthorizationListInput"
                                  class="form-control searchInputTree"
                                  type="text"
                                  placeholder="Arama yapınız"
                                  @input="setFilteredArrangedCategories($event)"
                                />

                                <!-- herhangi bir öge seçilirse burada gözükecek.
                                  her zaman kapalı gözükecek basınca açılacak ve buradan kaldırırsa listeden kalkacak -->
                                <!-- tree view -->
                                <section class="treeViewSidebar p-0">
                                  <ul class="mainUl p-0">
                                    <category-tree
                                      v-for="(category, categoryIndex) in filteredArrangedCategories"
                                      :key="'arrangedCategories' + category.id + categoryIndex"
                                      :category="category"
                                      :category-index="categoryIndex"
                                      :check-category="checkCategory"
                                      :check-category-change-event="checkCategoryChangeEvent"
                                      :match-selected-resources="matchSelectedResources"
                                      :check-change-event="checkChangeEvent"
                                    />
                                    <!-- yönetici işlemler -->
                                  </ul>
                                </section>
                              </b-tab>

                              <!--//todo oğuzhan abi ve armağanın bilgisi dahilinde kapatıldı-->

                              <!--<b-tab title="Yetki Gruplarından Seç">-->
                              <!--  &lt;!&ndash; tab area  &ndash;&gt;-->
                              <!--  &lt;!&ndash;search&ndash;&gt;-->
                              <!--  <input-->
                              <!--    class="form-control searchInputTree"-->
                              <!--    v-model="searchTextArrangedCategoryGroups"-->
                              <!--    type="text"-->
                              <!--    placeholder="Arama yapınız"-->
                              <!--  />-->

                              <!--  &lt;!&ndash; herhangi bir öge seçilirse burada gözükecek.
                                her zaman kapalı gözükecek basınca açılacak ve buradan kaldırırsa listeden kalkacak &ndash;&gt;-->
                              <!--  &lt;!&ndash; tree view &ndash;&gt;-->
                              <!--  <section class="treeViewSidebar p-0">-->
                              <!--    <ul class="mainUl p-0">-->
                              <!--      <template v-for="(group, groupIndex) in arrangedCategoryGroups" v-if="shouldShowArrangedCategoryGroups(group)">-->
                              <!--        <li-->
                              <!--          :key="'arrangedCategoryGroups' + groupIndex"-->
                              <!--          :id="'arrangedCategoryGroups' + groupIndex"-->
                              <!--          @click="openTreeView(groupIndex)"-->
                              <!--        >-->
                              <!--          <div class="row align-items-center no-gutters colArea flex-nowrap">-->
                              <!--            &lt;!&ndash; checkbox &ndash;&gt;-->
                              <!--            <div class="col-auto">-->
                              <!--              <div class="form-check pl-0 relativeChekBox d-flex">-->
                              <!--                <label class="checkboxArea align-items-center m-0">-->
                              <!--                  <input-->
                              <!--                    type="checkbox"-->
                              <!--                    :checked="checkCategoryGroup(group)"-->
                              <!--                    @change="checkCategoryGroupChangeEvent(group, groupIndex)"-->
                              <!--                  />-->
                              <!--                  <span class="checkmark"></span>-->
                              <!--                </label>-->
                              <!--              </div>-->
                              <!--            </div>-->
                              <!--            &lt;!&ndash; text &ndash;&gt;-->
                              <!--            <div class="col d-flex align-items-center">-->
                              <!--              &lt;!&ndash; açık olması için class : mainHeadOpen &ndash;&gt;-->
                              <!--              <span class="mainHead">{{ group.name }}</span>-->
                              <!--            </div>-->
                              <!--          </div>-->
                              <!--        </li>-->
                              <!--      </template>-->
                              <!--    </ul>-->
                              <!--  </section>-->
                              <!--</b-tab>-->
                            </b-tabs>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-md-6 authorizationManagement">
                <section class="mainTabMenu h-100">
                  <section class="unitTree">
                    <!-- selected items -->
                    <div class="selectedTreeView">
                      <div class="row no-gutters h-100 mainTabMenu">
                        <div class="col-12 customHeight">
                          <div class="row no-gutters">
                            <!-- kullanıcı yetkilendirme start -->
                            <!-- kullanıcı yetkilendirme end -->
                            <!-- head -->
                            <section class="col-12">
                              <h1 class="head">{{ selectedHeadText }}</h1>
                            </section>
                            <!-- custom hr -->
                            <section class="col-12">
                              <hr class="customHr" />
                            </section>

                            <!-- herhangi bir öge seçilirse burada gözükecek.
                              her zaman kapalı gözükecek basınca açılacak ve buradan kaldırırsa listeden kalkacak -->
                            <!-- tree view -->
                            <section class="col-12">
                              <!--sol taraftaki treeView den butonlardan tıkladığının adı seçili olan şeyin adı gelecek-->
                              <h6 class="headSelectedRole">{{ selectedRoleWithSubModel.name }}</h6>
                              <section class="treeViewSidebar p-0">
                                <ul class="mainUl p-0">
                                  <b-tabs
                                    :id="'AuthorizationManagementTreeViewSelectedTab'"
                                    v-model="selectedTreeViewTabIndex"
                                    pills
                                    fill
                                    justified
                                    :nav-class="'scrollbar tabChange'"
                                    :active-nav-item-class="'bg-primary'"
                                  >
                                    <!--search-->
                                    <input
                                      v-if="selectedTreeViewTabIndex === 0"
                                      v-model="searchTextChosenRoles"
                                      aria-label="searchChosenRolesInput"
                                      class="form-control searchInputTree"
                                      type="text"
                                      placeholder="Arama yapınız"
                                      @input="setFilteredChosenRoles($event)"
                                    />

                                    <input
                                      v-else-if="selectedTreeViewTabIndex === 1"
                                      v-model="searchTextChosenCategoryGroups"
                                      aria-label="searchChosenCategoryGroupsInput"
                                      class="form-control searchInputTree"
                                      type="text"
                                      placeholder="Arama yapınız"
                                    />
                                    <b-tab title="Yetki Listesinden Seç" active>
                                      <category-tree
                                        v-for="(category, categoryIndex) in filteredChosenRolesList"
                                        :key="'chosenRolesList' + category.id + categoryIndex"
                                        :category="category"
                                        :category-index="categoryIndex"
                                        :check-category="checkCategoryForSelected"
                                        :check-category-change-event="checkCategoryChangeEventForSelected"
                                        :match-selected-resources="matchSelectedResourcesForSelected"
                                        :check-change-event="checkChangeEventForSelected"
                                      />
                                    </b-tab>
                                    <!--//todo oğuzhan abi ve armağanın bilgisi dahilinde kapatıldı-->
                                    <!--<b-tab title="Yetki Gruplarından Seç">-->
                                    <!--  &lt;!&ndash; yetki grup ise &ndash;&gt;-->
                                    <!--  <template v-for="(group, groupIndex) in chosenCategoryGroups" v-if="shouldShowChosenCategoryGroups(group)">-->
                                    <!--    <li-->
                                    <!--      :key="'chosenCategoryGroups' + groupIndex"-->
                                    <!--      :id="'chosenCategoryGroups' + groupIndex"-->
                                    <!--      @click="openTreeView(groupIndex)"-->
                                    <!--    >-->
                                    <!--      <div class="row align-items-center no-gutters colArea flex-nowrap">-->
                                    <!--        &lt;!&ndash; checkbox &ndash;&gt;-->
                                    <!--        <div class="col-auto">-->
                                    <!--          <div class="form-check pl-0 relativeChekBox d-flex">-->
                                    <!--            <label class="checkboxArea align-items-center m-0">-->
                                    <!--              <input-->
                                    <!--                type="checkbox"-->
                                    <!--                :checked="checkCategoryGroup(group)"-->
                                    <!--                @change="checkCategoryGroupChangeEvent(group, groupIndex)"-->
                                    <!--              />-->
                                    <!--              <span class="checkmark"></span>-->
                                    <!--            </label>-->
                                    <!--          </div>-->
                                    <!--        </div>-->
                                    <!--        &lt;!&ndash; text &ndash;&gt;-->
                                    <!--        <div class="col d-flex align-items-center">-->
                                    <!--          &lt;!&ndash; açık olması için class : mainHeadOpen &ndash;&gt;-->
                                    <!--          <span class="mainHead">{{ group.name }}</span>-->
                                    <!--        </div>-->
                                    <!--      </div>-->
                                    <!--    </li>-->
                                    <!--  </template>-->
                                    <!--</b-tab>-->
                                  </b-tabs>
                                </ul>
                              </section>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </section>
              </div>
            </div>
            <!--            <div class="row">-->
            <!--              &lt;!&ndash;save button&ndash;&gt;-->
            <!--              <div class="col-12 my-4">-->
            <!--                <div class="row justify-content-end align-items-center">-->
            <!--                  <div class="col-auto">-->
            <!--                    <button-->
            <!--                      type="button"-->
            <!--                      class="btn btn-primary btn-lg"-->
            <!--                      :class="{ disabled: chosenRolesList.length === 0 }"-->
            <!--                      data-toggle="modal"-->
            <!--                      :data-target="saveDataTarget"-->
            <!--                      @click="$emit('saveSelectedRoleWithSubModel')"-->
            <!--                    >-->
            <!--                      Kaydet-->
            <!--                    </button>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryTree from "./CategoryTree.vue";
import WorkFlowControlBox from "./element/WorkFlowControlBox.vue";
import EntityStatus from "./list-pages/EntityStatus.vue";
import serviceResponseHelper from "../mixins/serviceResponseHelper";

export default {
  name: "RoleManagement",
  components: { EntityStatus, WorkFlowControlBox, CategoryTree },
  mixins: [serviceResponseHelper],
  props: {
    selectedRoleWithSubModel: {
      type: Object,
      default: () => ({ name: "", resources: [], resourceGroups: [] }),
    },
    arrangedCategories: {
      type: Array,
      default: () => [],
    },
    filteredRolesWithSubModels: {
      type: Array,
      default: () => [],
    },
    selectedTempId: {
      type: String,
      default: "",
    },
    chosenRolesList: {
      type: Array,
      default: () => [],
    },
    isNotSelectedRole: {
      type: Boolean,
      default: true,
    },
    selectedRolesToBeAdded: {
      type: Array,
      default: () => [],
    },
    selectedRolesToBeRemoved: {
      type: Array,
      default: () => [],
    },
    leftListHeadText: {
      type: String,
      default: "Yetki Listesi",
    },
    textRoleSearch: {
      type: String,
      default: "Yetki vermek istediğiniz rolü seçiniz",
    },
    overlayWarningMessage: {
      type: String,
      default: "Lütfen önce rol adı seçiniz.",
    },
    selectedSources: {
      type: Array,
      default: () => [],
    },
    selectedHeadText: {
      type: String,
      default: "Seçili Yetki Listesi",
    },
    selectedSourcesForSelected: {
      type: Array,
      default: () => [],
    },
    saveDataTarget: {
      type: String,
      default: "#saveModal",
    },
    headerText: {
      type: String,
      default: "Rol Adı",
    },
    btnAddDataToggle: {
      type: String,
      default: "modal",
    },
    btnAddDataTarget: {
      type: String,
      default: "#addRoleModal",
    },
    loadingBtnState: {
      type: String,
      default: "",
    },

    deletePermission: {
      type: Boolean,
      default: false,
    },
    updatePermission: {
      type: Boolean,
      default: true,
    },
    publishPermission: {
      type: Boolean,
      default: false,
    },
    rejectPermission: {
      type: Boolean,
      default: false,
    },
    recallPermission: {
      type: Boolean,
      default: false,
    },
    submitForApprovalPermission: {
      type: Boolean,
      default: false,
    },
    cancelPermission: {
      type: Boolean,
      default: false,
    },
    isSelectedRoleStatusWaitingApproval: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnRoleListCollapse: false,
      selectedTabIndex: 0,
      selectedTreeViewTabIndex: 0,
      searchTextArrangedCategories: "",
      filterSearchInput: "",
      searchTextChosenCategoryGroups: "",
      searchTextArrangedCategoryGroups: "",
      searchTextChosenRoles: "",
    };
  },
  computed: {
    filteredArrangedCategories() {
      const searchText = this.searchTextArrangedCategories.toLocaleLowerCase("tr-TR");

      const filterItems = (arr) => {
        return arr.reduce((filtered, item) => {
          const matchesCategory = item.name && item.name.toLocaleLowerCase("tr-TR").includes(searchText);
          const filteredResources = item.resources ? item.resources.filter((resource) => resource.name.toLocaleLowerCase("tr-TR").includes(searchText)) : [];

          // Alt kategorileri recursive olarak filtrele
          const filteredSubCategory = item.subCategory ? filterItems(item.subCategory) : [];

          // Alt kategorilerde görünür kaynakları kontrol et
          const hasVisibleChildren = filteredResources.length > 0 || filteredSubCategory.length > 0;

          // Eğer arama metni varsa, genişletme işlemini yap
          if (searchText) {
            if (matchesCategory || hasVisibleChildren) {
              filtered.push({
                ...item,
                resources: filteredResources,
                subCategory: filteredSubCategory,
                isOpen: true, // Eşleşme varsa aç
              });
            }
          } else {
            // Eğer arama metni yoksa, isOpen'ı false yap
            filtered.push({
              ...item,
              resources: filteredResources,
              subCategory: filteredSubCategory,
              isOpen: false, // Arama yoksa kapalı
            });
          }
          return filtered;
        }, []);
      };

      // Ana listeyi filtrele
      const filteredList = filterItems(this.arrangedCategories);
      const filterCategories = (categories) => {
        return categories
          .map((category) => {
            // Filtrelenmiş alt kategorileri al
            const filteredSubCategory = filterCategories(category.subCategory);

            // Eğer alt kategoride en az bir resource varsa veya alt kategorileri varsa, kategori geçerli sayılır
            if (category.resources.length > 0 || filteredSubCategory.length > 0) {
              return {
                ...category,
                subCategory: filteredSubCategory, // Filtrelenmiş alt kategorileri ata
              };
            }
            // Aksi takdirde null döndür, bu da silineceği anlamına gelir
            return null;
          })
          .filter(Boolean); // null olanları filtrele
      };
      return filterCategories(filteredList);
    },
    filteredChosenRolesList() {
      const searchText = this.searchTextChosenRoles.toLocaleLowerCase("tr-TR");

      const filterItems = (arr) => {
        return arr.reduce((filtered, item) => {
          const matchesCategory = item.name && item.name.toLocaleLowerCase("tr-TR").includes(searchText);
          const filteredResources = item.resources ? item.resources.filter((resource) => resource.name.toLocaleLowerCase("tr-TR").includes(searchText)) : [];

          // Alt kategorileri recursive olarak filtrele
          const filteredSubCategory = item.subCategory ? filterItems(item.subCategory) : [];

          // Alt kategorilerde görünür kaynakları kontrol et
          const hasVisibleChildren = filteredResources.length > 0 || filteredSubCategory.length > 0;

          // Eğer arama metni varsa, genişletme işlemini yap
          if (searchText) {
            if (matchesCategory || hasVisibleChildren) {
              filtered.push({
                ...item,
                resources: filteredResources,
                subCategory: filteredSubCategory,
                isOpen: true, // Eşleşme varsa aç
              });
            }
          } else {
            // Eğer arama metni yoksa, isOpen'ı false yap
            filtered.push({
              ...item,
              resources: filteredResources,
              subCategory: filteredSubCategory,
              isOpen: false, // Arama yoksa kapalı
            });
          }
          return filtered;
        }, []);
      };

      const filteredList = filterItems(this.chosenRolesList);
      const filterCategories = (categories) => {
        return categories
          .map((category) => {
            // Filtrelenmiş alt kategorileri al
            const filteredSubCategory = filterCategories(category.subCategory);

            // Eğer alt kategoride en az bir resource varsa veya alt kategorileri varsa, kategori geçerli sayılır
            if (category.resources.length > 0 || filteredSubCategory.length > 0) {
              return {
                ...category,
                subCategory: filteredSubCategory, // Filtrelenmiş alt kategorileri ata
              };
            }
            // Aksi takdirde null döndür, bu da silineceği anlamına gelir
            return null;
          })
          .filter(Boolean); // null olanları filtrele
      };
      return filterCategories(filteredList);
    },
  },
  methods: {
    checkCategoryForSelected(category) {
      if (category && category.resources) {
        if (!this.selectedSourcesForSelected) {
          return false;
        }
        const categoryResources = this.selectedSourcesForSelected.filter((value) => value.categoryId === category.id);
        const subCategoriesSelected =
          category.subCategory && category.subCategory.length > 0 ? category.subCategory.every((subCat) => this.checkCategoryForSelected(subCat)) : true;
        return subCategoriesSelected && categoryResources.length === category.resources.length;
      }
      return false;
    },
    checkCategoryChangeEventForSelected(category, categoryIndex, event) {
      const isChecked = event.target.checked;
      this.updateCategoryStatusForSelected(category, isChecked);
    },
    updateResourcesAndSubCategoriesForSelected(category, isChecked) {
      // Kaynakları güncelle
      if (category.resources && category.resources.length > 0) {
        category.resources.forEach((resource) => this.checkChangeEventForSelected(resource, category, isChecked));
      }

      // Alt kategorileri güncelle
      if (category.subCategory && category.subCategory.length > 0) {
        category.subCategory.forEach((subCat) => this.updateResourcesAndSubCategoriesForSelected(subCat, isChecked));
      }
    },
    updateCategoryStatusForSelected(category, isChecked) {
      // Kategoriyi ve tüm alt kategorileri ve kaynakları güncelle
      this.updateResourcesAndSubCategoriesForSelected(category, isChecked);

      // Alt kategoriler ve kaynaklar tamamlandığında üst kategorileri güncelle
      if (category.parentId !== 0) {
        const parentCategory = this.findNodeById(this.arrangedCategories, category.parentId);
        if (parentCategory) {
          const allSubSelected = parentCategory.subCategory.every((subCat) => this.checkCategoryForSelected(subCat));
          const allResourcesSelected = parentCategory.resources.every((resource) =>
            this.selectedSourcesForSelected.some((selectedResource) => selectedResource.id === resource.id)
          );
          if (allSubSelected && allResourcesSelected) {
            this.updateCategoryStatusForSelected(parentCategory, true);
          }
        }
      }
    },
    matchSelectedResourcesForSelected(resource) {
      if (!this.selectedSourcesForSelected) {
        return false;
      }
      return this.selectedSourcesForSelected.some((selectedResource) => selectedResource.id === resource.id);
    },
    checkChangeEventForSelected(resource, category, isChecked) {
      // Seçilen kaynakları güncelle
      const resourceIndex = this.selectedSourcesForSelected.findIndex((item) => item.id === resource.id);

      if (isChecked) {
        if (resourceIndex === -1) {
          this.selectedSourcesForSelected.push(JSON.parse(JSON.stringify(resource)));
        }
      } else {
        if (resourceIndex !== -1) {
          this.selectedSourcesForSelected.splice(resourceIndex, 1);
        }
      }

      // Kategori ve kaynak yönetimi
      const existingMainCategory = this.selectedRolesToBeRemoved.find((mainCategory) => mainCategory.id === category.id);

      if (isChecked) {
        if (existingMainCategory) {
          const resourceIndexInRemoved = existingMainCategory.resources.findIndex((existingResource) => existingResource.id === resource.id);
          if (resourceIndexInRemoved === -1) {
            existingMainCategory.resources.push(JSON.parse(JSON.stringify(resource)));
          }
        } else {
          const mainCategory = {
            id: category.id,
            name: category.name,
            parentId: category.parentId,
            resources: [JSON.parse(JSON.stringify(resource))],
          };
          this.selectedRolesToBeRemoved.push(mainCategory);
        }
      } else {
        if (existingMainCategory) {
          const resourceIndexInRemoved = existingMainCategory.resources.findIndex((existingResource) => existingResource.id === resource.id);
          if (resourceIndexInRemoved !== -1) {
            existingMainCategory.resources.splice(resourceIndexInRemoved, 1);
            if (existingMainCategory.resources.length === 0) {
              this.$emit(
                "emitSetSelectedRolesToBeRemoved",
                this.selectedRolesToBeRemoved.filter((mainCategory) => mainCategory.id !== category.id)
              );
            }
          }
        }
      }
    },
    setFilteredChosenRoles(event) {
      this.searchTextChosenRoles = event.target.value.toLocaleLowerCase("tr-TR");
    },
    matchSelectedResources(resource) {
      if (!this.selectedSources) {
        return false;
      }
      return this.selectedSources.some((selectedResource) => selectedResource.id === resource.id);
    },
    checkChangeEvent(resource, category, isChecked) {
      // Seçilen kaynakları güncelle
      const resourceIndex = this.selectedSources.findIndex((item) => item.id === resource.id);
      if (isChecked) {
        if (resourceIndex === -1) {
          this.selectedSources.push(JSON.parse(JSON.stringify(resource)));
        }
      } else {
        if (resourceIndex !== -1) {
          this.selectedSources.splice(resourceIndex, 1);
        }
      }

      // Kategori ve kaynak yönetimi
      const existingMainCategory = this.selectedRolesToBeAdded.find((mainCategory) => mainCategory.id === category.id);
      if (isChecked) {
        if (existingMainCategory) {
          const resourceIndexInAdded = existingMainCategory.resources.findIndex((existingResource) => existingResource.id === resource.id);
          if (resourceIndexInAdded === -1) {
            existingMainCategory.resources.push(JSON.parse(JSON.stringify(resource)));
          }
        } else {
          const mainCategory = {
            id: category.id,
            name: category.name,
            parentId: category.parentId,
            resources: [JSON.parse(JSON.stringify(resource))],
          };
          this.selectedRolesToBeAdded.push(mainCategory);
        }
      } else {
        if (existingMainCategory) {
          const resourceIndexInAdded = existingMainCategory.resources.findIndex((existingResource) => existingResource.id === resource.id);
          if (resourceIndexInAdded !== -1) {
            existingMainCategory.resources.splice(resourceIndexInAdded, 1);
            if (existingMainCategory.resources.length === 0) {
              this.$emit(
                "emitSetSelectedRolesToBeAdded",
                this.selectedRolesToBeAdded.filter((mainCategory) => mainCategory.id !== category.id)
              );
            }
          }
        }
      }
    },
    checkCategoryChangeEvent(category, categoryIndex, event) {
      const isChecked = event.target.checked;
      this.updateCategoryStatus(category, isChecked);
    },
    updateCategoryStatus(category, isChecked) {
      // Kategoriyi ve tüm alt kategorileri ve kaynakları günceller
      this.updateResourcesAndSubCategories(category, isChecked);

      // Alt kategoriler ve kaynaklar tamamlandığında üst kategorileri günceller
      if (category.parentId !== 0) {
        const parentCategory = this.findNodeById(this.arrangedCategories, category.parentId);
        if (parentCategory) {
          const allSubSelected = parentCategory.subCategory.every((subCat) => this.checkCategory(subCat));
          const allResourcesSelected = parentCategory.resources.every((resource) =>
            this.selectedSources.some((selectedResource) => selectedResource.id === resource.id)
          );
          if (allSubSelected && allResourcesSelected) {
            this.updateCategoryStatus(parentCategory, true);
          }
        }
      }
    },
    updateResourcesAndSubCategories(category, isChecked) {
      // Kaynakları günceller
      if (category.resources && category.resources.length > 0) {
        category.resources.forEach((resource) => this.checkChangeEvent(resource, category, isChecked));
      }

      // Alt kategorileri günceller
      if (category.subCategory && category.subCategory.length > 0) {
        category.subCategory.forEach((subCat) => this.updateResourcesAndSubCategories(subCat, isChecked));
      }
    },
    checkCategory(category) {
      if (category && category.resources) {
        if (!this.selectedSources) {
          return false;
        }
        const categoryResources = this.selectedSources.filter((value) => value.categoryId === category.id);
        const subCategoriesSelected =
          category.subCategory && category.subCategory.length > 0 ? category.subCategory.every((subCat) => this.checkCategory(subCat)) : true;
        return subCategoriesSelected && categoryResources.length === category.resources.length;
      }
      return false;
    },
    shouldShowArrangedCategoryGroups(item) {
      const searchTextLowerCase = this.searchTextArrangedCategoryGroups.toLocaleLowerCase("tr-TR");

      return this.searchTextArrangedCategoryGroups === "" || item.name.toLocaleLowerCase("tr-TR").includes(searchTextLowerCase);
    },
    shouldShowChosenCategoryGroups(item) {
      const searchTextLowerCase = this.searchTextChosenCategoryGroups.toLocaleLowerCase("tr-TR");

      return this.searchTextChosenCategoryGroups === "" || item.name.toLocaleLowerCase("tr-TR").includes(searchTextLowerCase);
    },
    // Kaynakları birleştiren yardımcı fonksiyon
    mergeResources(existingSubCategory, newResources) {
      for (let newResource of newResources) {
        let resourceExists = existingSubCategory.resources.some((existingResource) => existingResource.id === newResource.id);
        if (!resourceExists) {
          existingSubCategory.resources.push(newResource);
        }
      }
    },
    // İstenen kategoriyi id'ye göre bulan yardımcı fonksiyon
    findNodeById(nodes, id) {
      for (const node of nodes) {
        if (node.id === id) {
          return node;
        }
        if (node.subCategory && node.subCategory.length > 0) {
          const found = this.findNodeById(node.subCategory, id);
          if (found) {
            return found;
          }
        }
      }
      return null;
    },
    // Kategori yolunu bulur
    findCategoryPath(nodeId) {
      const node = this.findNodeById(this.arrangedCategories, nodeId);
      if (node) {
        return this.createCategoryPath(node);
      }
      return [];
    },
    mergeOrAddCategory(array, newCategory) {
      // Recursive function to merge categories
      function mergeCategories(existing, newCat) {
        for (let key in newCat) {
          if (Array.isArray(newCat[key])) {
            if (!existing[key]) {
              existing[key] = [];
            }
            newCat[key].forEach((newItem) => {
              let existingItem = existing[key].find((item) => item.id === newItem.id);
              if (existingItem) {
                mergeCategories(existingItem, newItem);
              } else {
                existing[key].push(newItem);
              }
            });
          } else if (typeof newCat[key] === "object" && newCat[key] !== null) {
            if (!existing[key]) {
              existing[key] = {};
            }
            mergeCategories(existing[key], newCat[key]);
          } else {
            existing[key] = newCat[key];
          }
        }
      }

      let existingCategory = array.find((item) => item.id === newCategory.id);
      if (existingCategory) {
        mergeCategories(existingCategory, newCategory);
      } else {
        array.push(newCategory);
      }
    },
    filterSearchRoles() {
      const filterSearchInputLowerCase = this.filterSearchInput.toLocaleLowerCase("tr-TR");
      this.$emit("emitFilterSearchInputLowerCase", filterSearchInputLowerCase);
    },
    setFilteredArrangedCategories(event) {
      this.searchTextArrangedCategories = event.target.value.toLocaleLowerCase("tr-TR");
    },
    addChosenRole() {
      this.selectedRolesToBeAdded.forEach((mainCategory) => {
        const parentCategoryId = mainCategory.parentId;
        // Find or create the parent category
        let parentCategory = this.findNodeById(this.chosenRolesList, parentCategoryId);

        if (!parentCategory && parentCategoryId !== 0) {
          // If parent category doesn't exist, create it based on the path
          const path = this.findCategoryPath(parentCategoryId);
          if (path.length > 0) {
            let newMainCategory = { id: path[0].id, name: path[0].name, parentId: 0, subCategory: [], resources: [] };
            let currentLevel = newMainCategory.subCategory;

            for (let i = 1; i < path.length; i++) {
              const category = path[i];
              let found = currentLevel.find((item) => item.id === category.id);
              if (!found) {
                found = { id: category.id, name: category.name, parentId: category.parentId, subCategory: [], resources: [] };
                currentLevel.push(found);
              }
              currentLevel = found.subCategory;
            }

            this.mergeOrAddCategory(this.chosenRolesList, newMainCategory);
            parentCategory = this.findNodeById(this.chosenRolesList, parentCategoryId);
          } else {
            console.error("Warning: Parent category not found and could not be added.");
            return;
          }
        }

        // If parent category doesn't exist and parentId is 0, add directly to chosenRolesList
        if (!parentCategory && parentCategoryId === 0) {
          parentCategory = { subCategory: this.chosenRolesList };
        }

        // Check if the main category already exists
        let existingMainCategory = this.findNodeById(parentCategory.subCategory || [], mainCategory.id);

        if (!existingMainCategory) {
          // If main category doesn't exist, add it
          parentCategory.subCategory = parentCategory.subCategory || [];
          parentCategory.subCategory.push({
            id: mainCategory.id,
            name: mainCategory.name,
            parentId: mainCategory.parentId,
            resources: mainCategory.resources,
            subCategory: [], // Initialize empty subcategory array for new subcategories
          });
        } else {
          // If main category exists, merge resources
          this.mergeResources(existingMainCategory, mainCategory.resources);
        }
      });

      // Reset selected roles and resources
      this.$nextTick(() => {
        this.$emit("resetSelectedFieldsByFieldNameList", [
          "selectedRolesToBeAdded",
          "selectedSources",
          "selectedRolesToBeRemoved",
          "selectedSourcesForSelected",
        ]);
      });
    },
    removeChosenRole() {
      this.selectedRolesToBeRemoved.forEach((mainCategory) => {
        this.removeCategory(mainCategory);
      });

      // Daha sonra seçilen rolleri ve kaynakları sıfırlayalım
      this.$nextTick(() => {
        this.$emit("resetSelectedFieldsByFieldNameList", ["selectedRolesToBeRemoved", "selectedSources", "selectedSourcesForSelected"]);
      });
    },
    removeCategory(category) {
      const removeResourceFromCategory = (cat, resource) => {
        const resourceIndex = cat.resources.findIndex((res) => res.id === resource.id);
        if (resourceIndex !== -1) {
          cat.resources.splice(resourceIndex, 1);
        }
      };

      const findAndRemoveCategory = (categories, categoryToRemove) => {
        for (let i = 0; i < categories.length; i++) {
          if (categories[i].id === categoryToRemove.id) {
            // Ana kategoriyi bulduğumuzda kaynakları kaldır
            categoryToRemove.resources.forEach((resource) => {
              removeResourceFromCategory(categories[i], resource);
            });

            // Eğer kategori boşsa, onu da listeden çıkar
            if (categories[i].resources.length === 0 && categories[i].subCategory.length === 0) {
              categories.splice(i, 1);
            }
            return true;
          } else if (categories[i].subCategory && categories[i].subCategory.length > 0) {
            // Alt kategorilerde aramaya devam et
            if (findAndRemoveCategory(categories[i].subCategory, categoryToRemove)) {
              if (categories[i].subCategory.length === 0 && categories[i].resources.length === 0) {
                categories.splice(i, 1);
              }
              return true;
            }
          }
        }
        return false;
      };

      findAndRemoveCategory(this.chosenRolesList, category);
    },
    getEntityStatus(entity) {
      if (!entity.intentId) return;
      if (entity.intentId !== 0) {
        return entity.intents[0].type + " | " + entity.intents[0].status;
      } else {
        return "PUBLISHED";
      }
    },
    // Kategori yolunu oluşturur
    createCategoryPath(node) {
      let path = [];
      let current = node;
      while (current) {
        path.unshift({
          id: current.id,
          name: current.name,
          parentId: current.parentId,
        });
        current = this.findNodeById(this.arrangedCategories, current.parentId);
      }
      return path;
    },
  },
};
</script>

<style scoped lang="scss">
.treeViewSidebar .mainUl .subUl .mainHead::before {
  display: none !important;
}

.authorizationManagementbreadcrumb {
  &.breadcrumbArea {
    margin: 15px 20px;

    .breadcrumb {
      margin: 0px;
    }
  }
}

.authorizationManagement .unitTree .selectedTreeView .treeViewSidebar {
  max-height: 494px;
}

.font-12 {
  font-size: 12px;
}

.iconArrowToggleLeft {
  margin-left: 60px !important;
  z-index: 1;
  padding: 0;
  border: 0;
  box-shadow: none !important;
  width: 24px;
  height: 24px;
  background-color: var(--white);
  border-radius: 12px;
  position: absolute;
  margin-top: 50px;

  &:after {
    z-index: -0000;
    content: "";
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: var(--blue-grey);
    background-color: transparent;
    border-top: 2px solid !important;
    border-right: 2px solid !important;
    min-width: 10px;
    min-height: 10px;
    width: 10px;
    height: 10px;
    border-left: none !important;
    border-bottom: none !important;
    float: right;
    cursor: pointer;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -5px;
    margin-left: -6px;
  }
}

.iconArrowToggleRight {
  margin-left: 0 !important;
  z-index: 1;
  padding: 0;
  border: 0;
  box-shadow: none !important;
  width: 24px;
  height: 24px;
  background-color: var(--white);
  border-radius: 12px;
  position: absolute;
  margin-top: 20px;
  right: 0;

  &:after {
    content: "";
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: var(--blue-grey);
    background-color: transparent;
    border-top: 2px solid !important;
    border-right: 2px solid !important;
    min-width: 10px;
    min-height: 10px;
    width: 10px;
    height: 10px;
    border-left: none !important;
    border-bottom: none !important;
    float: right;
    cursor: pointer;
    transform: rotate(225deg);
    -webkit-transform: rotate(225deg);
    -moz-transform: rotate(225deg);
    -ms-transform: rotate(225deg);
    -o-transform: rotate(225deg);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -5px;
    margin-left: -3px;
  }
}

.iconArrowToggleThird {
  margin-left: 342px !important;
  z-index: 1;
  padding: 0;
  border: 0;
  box-shadow: none !important;
  width: 24px;
  height: 24px;
  background-color: var(--white);
  border-radius: 12px;
  position: absolute;
  margin-top: 20px;

  &:after {
    content: "";
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: var(--blue-grey);
    background-color: transparent;
    border-top: 2px solid !important;
    border-right: 2px solid !important;
    min-width: 10px;
    min-height: 10px;
    width: 10px;
    height: 10px;
    border-left: none !important;
    border-bottom: none !important;
    float: right;
    cursor: pointer;
    transform: rotate(225deg);
    -webkit-transform: rotate(225deg);
    -moz-transform: rotate(225deg);
    -ms-transform: rotate(225deg);
    -o-transform: rotate(225deg);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -5px;
    margin-left: -3px;
  }
}

.bgDarkBlueGrey {
  background-color: var(--dark-blue-grey);
}
.btnRoleListCollapse {
  padding: 14px 10px;
}
.iconArrowToggleLeft {
  margin-left: -35px !important;
  margin-top: 20px !important;
}
.stationTable {
  display: inline-flex !important;
  flex-direction: column;
  .statusEntity {
    &.statusSuccess {
      font-size: 12px;
      width: 75px;
    }
  }
}
.btnRole {
  display: block !important;
}
.tooltipUser {
  opacity: 1 !important;
  text-align: left;

  &::v-deep .tooltip-inner {
    text-align: left;
    max-width: 330px;
  }
  &:not(.fade):not(.show) {
    opacity: 1;
    outline: 0;
    display: block;
  }
}
.statusArea {
  margin-top: 15px;
}
</style>
